module.exports = __webpack_public_path__ + "72d892d6c566fa665d683bce8b6859fb.svg";